module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.ready) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [(_vm.error) ? _c('v-layout', [_c('app-alert', {
    attrs: {
      "text": _vm.error.message
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "success",
      "dismissible": "",
      "value": _vm.linkSuccess
    }
  }, [_vm._v("\n                You will receive an email with a link to reset your password.\n              ")]), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.requestPassworReset.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Email",
      "id": "email",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.linkSuccess,
      "block": "",
      "type": "submit",
      "color": "primary",
      "loading": _vm.loading
    }
  }, [_vm._v("Request Password Link")])], 1)], 1)], 1)])], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31d98378","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/ResetPassword.vue
// module id = 666
// module chunks = 1